import { Button, ButtonProps } from "antd";
import { ReactElement } from "react";
import { Link } from "react-router-dom";

import styles from "./AntDButtonLink.module.scss";

interface AntDButtonLinkProps extends Omit<ButtonProps, "className"> {
  text?: string | ReactElement;
  style?: React.CSSProperties;
  pathname: string;
  search?: string;
  state?: any;
  onClick?: () => void;
  target?: React.HTMLAttributeAnchorTarget;
  noPadding?: boolean;
}

export const AntDButtonLink: React.FC<AntDButtonLinkProps> = ({
  pathname,
  text,
  onClick,
  style,
  search,
  state,
  target,
  noPadding,
  ...props
}) => {
  return (
    <Link to={{ pathname, search, state }} style={style} target={target}>
      <Button
        onClick={onClick}
        {...props}
        className={styles.buttonLink}
        style={{ padding: noPadding ? 0 : "undefined" }}
      >
        {text}
      </Button>
    </Link>
  );
};
